import React from 'react';
import LoanProgramTemplate from './LoanProgramTemplate';

export default function ARMLoanPage() {
  return (
    <LoanProgramTemplate
      title="Adjustable-Rate Mortgage Program"
      subtitle="Our Loan Programs"
      heroImage="https://res.cloudinary.com/ddhrdxc7d/image/upload/v1778098866/in-flight_3_n3rham.png"
      contentImage="https://res.cloudinary.com/ddhrdxc7d/image/upload/v1790172412/arm_photo_ufccm2.jpg"
      descriptionBold="Adjustable-Rate Mortgages (ARMs)"
      description="offer an interest rate that is fixed for an initial period and may adjust periodically afterward. With multiple ARM options available, borrowers can choose a structure that aligns with their homeownership timeline and financial goals."
      whyBuyersConsider="ARMs can provide financing flexibility for buyers who may not plan to stay in their home long term, expect their financial situation to change, or want to explore alternatives to a traditional fixed-rate mortgage."
      eligibilityItems={[
        'Minimum credit score requirements apply',
        'Income and employment must meet applicable program guidelines',
        'Standard debt-to-income requirements apply',
        'Down payment requirements vary by loan program and borrower profile',
        'Property and occupancy requirements may apply',
        'Borrowers must qualify based on the specific ARM program selected',
      ]}
      benefitsItems={[
        'Initial interest rate is fixed for a specified period',
        'Multiple ARM structures may be available',
        'May offer a lower initial interest rate than certain fixed-rate loan options',
        'Can be a useful option for borrowers with shorter homeownership timelines',
        'Rate caps help limit how much the interest rate can adjust at specified intervals',
        'Provides an alternative to traditional fixed-rate financing',
      ]}
    />
  );
}
